import { call, put, takeLatest } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { callGetAPI } from "../API";
import { SERVER_API } from "../../helper/Constants";

function* fetchUser(action) {
  try {
    const userData = yield call(() =>
      callGetAPI(SERVER_API.USER_LOGIN, action.data),
    );
    yield put({ type: sagaActions.USER_LOGIN, data: userData });
  } catch (e) {
    yield put({ type: sagaActions.USER_LOGIN_FAILED, message: e.message });
  }
}

function* watchUserLoginAsync() {
  yield takeLatest(sagaActions.USER_LOGIN_REQUEST, fetchUser);
}

export default watchUserLoginAsync;
